module.exports = __webpack_public_path__ + "img/devider.e2d28865.png";